import { html, TemplateResult } from 'lit-element';
import getString from '../strings';
import { ActionBarHandler, KatDataGridActionBar } from './action-bar';

export class EditActionBarHandler implements ActionBarHandler {
  renderBarContent(container: KatDataGridActionBar): TemplateResult {
    return html`<kat-button
        class="cancel-bulk-edit"
        variant="secondary"
        label="${getString('dg-cancel')}"
        data-func="cancel"
        @click="${() => container.dispatchEvent(new Event('cancel-bulk-edit'))}"
        part="edit-actionbar-cancel"
      ></kat-button>
      <kat-button
        class="save-bulk-edit"
        label="${getString('dg-save')}"
        data-func="save"
        @click="${() => container.dispatchEvent(new Event('save-bulk-edit'))}"
        part="edit-actionbar-save"
      ></kat-button>`;
  }

  firstUpdated(): void {}
}
